<template>
    <v-tab-item :value="thisTab" class="fill-height pa-16">
        <v-layout column justify-center class="h-100 mx-auto" style="max-width: 1224px">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <v-layout justify-center align-center class="fill-height">
                    <v-card flat rounded="xl" style="min-width: 320px; min-height: 240px; overflow: hidden">
                        <v-responsive :aspect-ratio="1 / 1">
                            <qrcode-stream-reader
                                v-model="decoded"
                                v-bind="{ propCamera }"
                                v-on="{
                                    input: onDecoded,
                                    changeCamera: (camera) => (propCamera = camera),
                                }"
                            >
                                <message-snackbar v-bind="{ message }" absolute bottom tile @close="message = null" />
                            </qrcode-stream-reader>
                        </v-responsive>
                    </v-card>
                </v-layout>
            </v-sheet>
            <div class="v-btn-group flex-wrap mt-16">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('exit')"
                >
                    <span class="grey-6--text">취소</span>
                </v-btn>
                <v-btn
                    color="primary"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        disabled,
                        loading,
                    }"
                    @click="next"
                >
                    <span> 다음 단계 </span>
                    <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import api from "@/api";
import { initAttendanceLog } from "@/store/attendance";
import { TABS } from "../lib";

import QrcodeStreamReader from "@/components/dumb/qrcode-stream-reader.vue";
import MessageSnackbar from "@/components/dumb/message-snackbar.vue";

const thisTab = TABS.SCAN.value;

export default {
    components: {
        QrcodeStreamReader,
        MessageSnackbar,
    },
    props: {
        value: { type: Object, defatul: initAttendanceLog },
        tab: { type: String, default: TABS.SCAN.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        form: initAttendanceLog(),
        decoded: null,
        message: null,
        propCamera: "auto",

        thisTab,
    }),
    computed: {
        isOn() {
            if (!this.shows) return false;
            if (this.tab != thisTab) return false;

            return true;
        },
        disabled() {
            return !this.form._code;
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
        isOn() {
            this.init();
        },
    },
    methods: {
        init() {
            this.decoded = null;
            this.message = null;
            this.propCamera = "auto";
        },
        sync() {
            this.form = initAttendanceLog(this.value);
        },
        emit() {
            this.$emit("input", this.form);
        },
        next() {
            try {
                if (!this.form._code) throw new Error("QR코드를 스캔해주세요");

                this.$emit("next");
            } catch (error) {
                alert(error.message);
            }
        },
        setLoading(loading) {
            this.$emit("setLoading", loading);
        },
        async onDecoded(decoded) {
            setTimeout(() => {
                if (decoded == this.decoded) {
                    this.message = null;
                    this.decoded = null;
                }
            }, 3000);

            try {
                decoded = JSON.parse(decoded);
            } catch {
                decoded = decoded;
            }
            if (!decoded?._code) {
                this.message = "정상적으로 스캔되지 않았습니다";
                return;
            }

            if (this.loading) return;
            else this.setLoading(true);
            try {
                let { _code } = decoded;
                let { code } = await api.v1.person.attendance.codes.get({ _id: _code });
                if (!code || !code?._company) {
                    throw new Error("해당 QR코드로 회사정보를 찾을 수 없습니다");
                }

                this.form._code = _code;
                this.form._company = code?._company;
                this.next();
            } catch (error) {
                alert(error.message);
            } finally {
                this.setLoading(false);
            }

            this.emit();
            this.message = "정상적으로 스캔되었습니다";
        },
    },
};
</script>

<style></style>
